import React from 'react'
import {useRoutes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Service from './pages/Service';
import Insights from './pages/Insights';
import MainInsights from './pages/MainInsights';
const RouterIndex = () => {
    const  routes = useRoutes([
        { path: "/", element: <Home /> },
        { path: "/about", element: <About /> },
        { path: "/contacts", element: <Contact /> },
        { path: "/new-insights", element: <MainInsights /> },
        { path: "/new-insights/:newName", element: <Insights /> },
        { path: "/:serviceName", element: <Service /> },
        // ...
      ]);
      return routes;
    };
export default RouterIndex
